import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import {
  DASHBOARD_ERROR_URL,
  EYEFINITY_URL,
  PeConnAccessToken,
  ROUTES_SIGNUP,
} from '@share/constants';
import { EyefinityDashboardService } from '../../eyefinity-dashboard/eyefinity-dashboard.service';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class EyefinityGuard {
  private router = inject(Router);
  private eyefinityDashboardService = inject(EyefinityDashboardService);

  accessToken: PeConnAccessToken;

  /**
   * Check for the existance of a token as a query parameter or in session Storage.  If a parameter recreate it as
   * a sessionStorage.  With the sessionStorage try to access client_id and efan.  Use those to validate client_id and
   * query efan status.  Based on that route to the correct landing page.  If anything goes wrong route
   * to api's refresh call to attempt to get a new token
   * @param next
   * @param state
   */
  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.accessToken = null;
    if (this.eyefinityDashboardService.hasToken()) {
      this.accessToken = this.eyefinityDashboardService.getPeConnAccessToken();
      return this.continueNavigation();
    } else {
      this.router.navigateByUrl(DASHBOARD_ERROR_URL);
      return of(false);
    }
  }

  continueNavigation(): Observable<boolean> {
    return this.eyefinityDashboardService
      .getInitialRoute$(this.accessToken.efan)
      .pipe(
        mergeMap((response) => {
          if (response) {
            // signup is no longer available for eyefinity users — if response is
            // ROUTES_SIGNUP we are already navigating to dashboard, so do nothing
            if (response !== ROUTES_SIGNUP) {
              this.router.navigate([EYEFINITY_URL + '/' + response]);
            }
            return of(true);
          }
          this.router.navigate([DASHBOARD_ERROR_URL]);
          return of(false);
        }),
        catchError((error) => {
          console.error('Encountered an error in eyefinity.guard: ', error);
          this.eyefinityDashboardService.removeEyefinityTokenFromStorage();
          this.router.navigateByUrl(DASHBOARD_ERROR_URL);
          this.handleError('No valid token was found');
          return of(false);
        }),
      );
  }

  // /**
  //  * Responsible for forcing a user to authenticate because we don't know who they are
  //  * @param params
  //  */
  // forceUserAuthentication(): Observable<boolean> {
  //   return this.eyefinityDashboardService.refreshEyefinityToken$()
  //     .pipe(
  //       map(token => {
  //         this.accessToken = token ? token : null;
  //         return !!this.accessToken;
  //       }),
  //       catchError(this.handleError)
  //     )
  // }

  private handleError(error): Observable<boolean> {
    console.error(
      'We were unable to properly authenticate you at this time. ',
      error,
    );
    this.eyefinityDashboardService.removeEyefinityTokenFromStorage();
    return of(false);
  }
}
